<template>
  <div v-if="step == 1" :class="{'active-page': active}">
    <div class="app-login-form-wrp">
      <h3>Which Phox Jug do you have?</h3>
      <div class="item-selct">
        <div class="single-item-slc" @click="active = 1" :class="{'active-item': active == 1}">
          <div class="jg-img">
            <img :src="`/assets/img/jugs/v1${active == 1 ? '-selected' : ''}.png`" alt />
          </div>
          <h4>V1</h4>
        </div>
        <div class="single-item-slc" @click="active = 2" :class="{'active-item': active == 2}">
          <div class="jg-img">
            <img :src="`/assets/img/jugs/v2${active == 2 ? '-selected' : ''}.png`" alt />
          </div>
          <h4>V2</h4>
        </div>
      </div>
    </div>
    <div v-if="active" style="margin-bottom: 10px;">
      <a @click.prevent="step = 2" class="btn-main">OKAY</a>
    </div>
  </div>
  <select-date v-else @next="okay" />
</template>

<script>
import { mapActions } from 'vuex'
import SelectDate from './SelectDate'
export default {
  components: {
    SelectDate
  },
  head: function() {
    return {
      title: {
        inner: 'Select Jug'
      }
    }
  },

  data() {
    return {
      active: 0,
      step: 1
    }
  },
  methods: {
    ...mapActions('authentication', {
      okay(dispatch, replacedAt) {
        dispatch('selectJug', {type: `v${this.active}`, replacedAt})
        this.$router.push('/indicator')
      }
    })
  }
}
</script>

<style>
</style>